import React, { useEffect } from "react";
import "./Footer.css";
import location from "./img/location.svg";
import mail from "./img/mail.svg";
import phoneCall from "./img/phonecall.svg";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";

const Footer = () => {
  useEffect(() => {
    AOS.init({ duration: 2000 });
  }, []);

  return (
    <div>
      <div className="limoFooter" data-aos="flip-right">
        <div className="limo">
          <h1>
            BENTRACO Logistics LLC is your number one choice for transportation.
          </h1>
          <p>Ask About our Daily Specials for the GA area!</p>
        </div>
        <a href="/booking">
          <button className="btnBookNow">Book Now!</button>
        </a>
      </div>

      <div className="linksFooter"data-aos="flip-left">
        <div className="Links">
          <ul className="uls">
            <li>
              <h1 className="quick">Quick Links</h1>
            </li>
            <Link to="/" className="link">
              <li className="links">Home</li>
            </Link>
            <Link to="/services" className="link">
              <li className="links">Services</li>
            </Link>
            <Link to="/contact" className="link">
              {" "}
              <li className="links">Contact Us</li>
            </Link>
            <Link to="/about" className="link">
              <li className="links">About us</li>
            </Link>
          </ul>
        </div>
        <div className="BOX">
          <h1 className="contactUs">Contact Us</h1>
          <div className="footbox">
            <img src={location} alt="" />
            <h5>2145 E West Connector Apt 202 Austell GA 30106-8191</h5>
          </div>
          <div className="footbox">
            <img src={mail} alt="" />
            <h5>bentracologistics@gmail.com</h5>
          </div>
          <div className="footbox">
            <img src={phoneCall} alt="" />
            <h5>+1 470 265-9412</h5>
          </div>
        </div>
      </div>

      <div className="copyright">
        <h5>
          © Copyright 2017. BENTRACO Logistics LLC. All Rights Reserved. | By:{" "}
          <span>Sundown Tech Solutions</span>
        </h5>
      </div>
    </div>
  );
};

export default Footer;
